module.exports = __webpack_public_path__ + "img/story013@2x.ae47d791.png";